export const finishModalItems = (that) => [
    {
        key: "aiChatbot",
        title: that.$t("setupWizard.aiChatbot.title"),
        videoUrl: "https://www.youtube.com/embed/ZlKXlxXADpY",
        docsUrl: "https://doc.supsis.live/supsis/chatbot/chatbotMenu",
    },
    {
        key: "aiAssistant",
        title: that.$t("setupWizard.aiAssistant.title"),
        docsUrl: "https://doc.supsis.live/supsis/integrations/whatIsIntegrations/#13-openai",
    },
    {
        key: "aiLiveSupport",
        title: that.$t("setupWizard.aiLiveSupport.title"),
        videoUrl: "https://www.youtube.com/embed/f04KqMCP6do",
        docsUrl: "https://doc.supsis.live/supsis/chat/chatMenuGeneral",
    },
    {
        key: "aiAutomation",
        title: that.$t("setupWizard.aiAutomation.title"),
        videoUrl: "https://www.youtube.com/embed/FLbxb5rcAnk",
        docsUrl: "https://doc.supsis.live/supsis/automations/automation",
    },
    {
        key: "aiDynamicCrm",
        title: that.$t("setupWizard.aiDynamicCrm.title"),
        docsUrl: "https://doc.supsis.live/supsis/settings/visitorProfileInformation",
    },
    {
        key: "whatsappBusiness",
        title: that.$t("setupWizard.whatsappBusiness.title"),
        videoUrl: "https://www.youtube.com/embed/w8cIMLuROgg",
        docsUrl: "https://doc.supsis.live/supsis/integrations/whatsappBusinessAPI",
    },
    {
        key: "whatsappWeb",
        title: that.$t("setupWizard.whatsappWeb.title"),
        videoUrl: "https://www.youtube.com/embed/7pfytsnBQmI",
        docsUrl: "https://doc.supsis.live/supsis/whatsapp/waQrIntegration",
    },
    {
        key: "instagram",
        title: that.$t("setupWizard.instagram.title"),
        videoUrl: "https://www.youtube.com/embed/zgTA5huIx_0",
        docsUrl: "https://doc.supsis.live/supsis/integrations/instagram",
    },
    {
        key: "facebook",
        title: that.$t("setupWizard.facebook.title"),
        videoUrl: "https://www.youtube.com/embed/WLpmHAiEJ64",
        docsUrl: "https://doc.supsis.live/supsis/messenger/howToAddMessengerChannel",
    },
    {
        key: "telegram",
        title: that.$t("setupWizard.telegram.title"),
        docsUrl: "https://doc.supsis.live/supsis/integrations/telegram",
    },
    {
        key: "mail",
        title: that.$t("setupWizard.mail.title"),
        videoUrl: "https://www.youtube.com/embed/YNtCELx_6j0",
        docsUrl: "https://doc.supsis.live/supsis/email/email",
    },
    {
        key: "metaLead",
        title: that.$t("setupWizard.metaLead.title"),
        docsUrl: "https://doc.supsis.live/supsis/invoice/packages/metaLeadPackages",
    },
    {
        key: "trendyol",
        title: that.$t("setupWizard.trendyol.title"),
        videoUrl: "https://www.youtube.com/embed/w037a9-3NSs",
        docsUrl: "https://doc.supsis.live/supsis/invoice/packages/trendyolPackages",
    },
    {
        key: "formSurvey",
        title: that.$t("setupWizard.formSurvey.title"),
        docsUrl: "https://doc.supsis.live/supsis/forms/createForm",
        videoUrl: "https://www.youtube.com/embed/LGOQbcai81s",
    },
    {
        key: "processManagement",
        title: that.$t("setupWizard.processManagement.title"),
        docsUrl: "https://doc.supsis.live/supsis/task/taskManagementPageGeneralFeatures",
        videoUrl: "https://www.youtube.com/embed/O_UXkT-xbNo",
    },
    {
        key: "calendar",
        title: that.$t("setupWizard.calendar.title"),
        docsUrl: "https://doc.supsis.live/supsis/calendar/calendarAndReservationUsage",
    },
    {
        key: "websiteAnalysis",
        title: that.$t("setupWizard.websiteAnalysis.title"),
        videoUrl: "https://www.youtube.com/embed/N5DdniEwsWg",
        docsUrl: "https://doc.supsis.live/supsis/reports/websiteAnalysis",
    },
    {
        key: "ticketSystem",
        title: that.$t("setupWizard.ticketSystem.title"),
        docsUrl: "https://doc.supsis.live/supsis/ticket/formTickets",
    },
    {
        key: "dynamicTables",
        title: that.$t("setupWizard.dynamicTables.title"),
        docsUrl: "https://doc.supsis.live/supsis/tables/tablesPagesGeneralFeatures",
    },
    {
        key: "aiVoice",
        title: that.$t("setupWizard.aiVoice.title"),
        docsUrl: "https://doc.supsis.live/supsis/aiAudioAgent/aiAudioAgentGeneral",
        videoUrl: "https://www.youtube.com/embed/-Cyxc3Qj1n4",
    },
];
